import React, { useState, useContext } from 'react'
import View from './View'
import Edit from './Edit'
import DataContext from '../../../contexts/DataContext'

const Personal = () => {
  const { advisor } = useContext(DataContext)

  const [isEdit, setIsEdit] = useState(false)
  const [profile, setProfile] = useState(advisor.expert)

  if (isEdit) {
    return (
      <Edit
        profile={profile}
        setProfile={setProfile}
        onSave={() => setIsEdit(false)}
      />
    )
  }

  return <View profile={profile} onEdit={() => setIsEdit(true)} />
}

export default Personal
